module.exports = __webpack_public_path__ + "img/works_xikemu_dx_3.45db0a2f.jpg";